import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Row, Col, Typography } from 'antd';
import AddForm from '../components/AddForm';
import { useDispatch, useSelector } from 'react-redux';
import { getVendorOption } from "../../ducks/actions";
import { addVendor } from "../../ducks/services"
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title } = Typography;

export default (props) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("1");
  const meta = useSelector((state) => state.inventory.option);
  const i18n = useTranslate();
    const { t } = i18n;

  useEffect(() => {
    dispatch(getVendorOption(props.setLoading))
  }, []);

  return (
    <Row gutter={[20, 30]}>
      <Col span={24}>
        <Row justify={'space-between'} align={'middle'}>
          <Col flex='auto'>
            <Title level={3} className='mb-0 mt-0'>{t("New.vendor")}</Title>
          </Col>
          <Col flex='auto' className='text-right'>
            <Space size={10}>
              <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/inventory/vendor')}>{'<'} {t("General.back")}</Button>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AddForm
          loading={props.loading}
          setLoading={props.setLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          oneTab={true}
          mode={'add'}
          addVendor={addVendor}
          navigate={navigate}
          meta={meta}
          reloadApi={(propId) => navigate(`/inventory/vendor/${propId}`)}
          allowedEdit={true}
        />
      </Col>
    </Row>
  )
}